import { useState, useEffect } from 'react';
import { GoChevronRight, GoChevronLeft } from "react-icons/go";

import "./style.css";

/**
 * 
 * @param {Object} props Contains 'currentPage', 'setCurrentPage' and 'projectCount' properties.
 * @returns Pagination component.
 */
export default function Pagination(props) {
  const [paginationBarContents, setPaginationBarContents] = useState([]);
  let pageCount = Math.ceil(props.projectCount / 8);

  function ToTheTop(){
    window.scrollTo(0, 0);
  }


  /**
   * Increases current page number by one. Changing currentPage re-fetches projects in searchBarSection.js.
   */
  function nextPage() {
    if(props.currentPage !== pageCount-1){
      props.setCurrentPage(prevstate => prevstate + 1);
      ToTheTop();
    }

  }


  /**
   * Decreases current page number by one. Changing currentPage re-fetches projects in searchBarSection.js.
   */
  function previousPage() {
    if (props.currentPage !== 0) {
      props.setCurrentPage(prevstate => prevstate - 1);
      ToTheTop();
    }
  }


  /**
   * Changes current page number to specified page.
   * @param {number} newPage New page to switch to.
   */
  function changePage(newPage) {
    props.setCurrentPage(newPage);
    ToTheTop();
  }


  //Update pagination component when project count or current page change.
  useEffect(() => {
    //    Possible cases for pagination component:
    //    < | 1 | 2 | 3 | 4 | 5 | 6 | > 
    //    < | 1 | 2 | 3 | 4 | 5 | ... | 9 | >
    //    < | 1 | ... | 3 | 4 | 5 | 6 | 7 | ... | 9 | >
    //    < | 1 | ... | 5 | 6 | 7 | 8 | 9 | >


    // Case for:    < | 1 | 2 | 3 | 4 | 5 | 6 | >   ------------------------------------------------------------------
    if (pageCount > 1 && pageCount <= 6) {
      let items = [];

      for (let i = 0; i < pageCount; i++) {
        if (props.currentPage === i) {
          items.push(<a onClick={() => changePage(i)} key={i} className="z-10 bg-blue-50 border-blue-500 text-blue-600 px-4 py-2 border text-sm font-medium dark:bg-gray-600 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700">{i + 1}</a>); //Active page number
        }
        else {
          items.push(<a onClick={() => changePage(i)} key={i} className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 px-4 py-2 border text-sm font-medium dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700">{i + 1}</a>); //Regular page number
        }
      }
      setPaginationBarContents(items);
    }


    // Case for:  < | 1 | 2 | 3 | 4 | 5 | ... | 9 | >   ------------------------------------------------------------------
    if (pageCount > 6 && props.currentPage < 5) {
      let items = [];

      for (let i = 0; i < 5; i++) {
        if (props.currentPage === i) {
          items.push(<a onClick={() => changePage(i)} key={i} className="z-10 bg-blue-50 border-blue-500 text-blue-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium dark:bg-gray-600 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700">{i + 1}</a>); //Active page number
        }
        else {
          items.push(<a onClick={() => changePage(i)} key={i} className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50  md:inline-flex relative items-center px-4 py-2 border text-sm font-medium dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700">{i + 1}</a>); //Regular page number
        }
      }
      items.push(<span key={-1} className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700">...</span>);
      items.push(<a onClick={() => changePage(pageCount - 1)} key={pageCount} className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50  md:inline-flex relative items-center px-4 py-2 border text-sm font-medium dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700">{pageCount}</a>);
      setPaginationBarContents(items);
    }


    // Case for: < | 1 | ... | 3 | 4 | 5 | 6 | 7 | ... | 9 | >  ------------------------------------------------------------------
    if (pageCount > 6 && props.currentPage > 3 && props.currentPage < pageCount - 4) {
      setPaginationBarContents(
        <>
          <a onClick={() => changePage(0)} key={0} className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50  md:inline-flex relative items-center px-4 py-2 border text-sm font-medium dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700">1</a>
          <span key={-2} className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700">...</span>

          <a onClick={() => changePage(props.currentPage - 2)} key={props.currentPage - 2} className="bg-white border-gray-300 hidden text-gray-500 hover:bg-gray-50  sm:inline-flex relative items-center px-4 py-2 border text-sm font-medium dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700">{props.currentPage - 1}</a>
          <a onClick={() => changePage(props.currentPage - 1)} key={props.currentPage - 1} className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50  md:inline-flex relative items-center px-4 py-2 border text-sm font-medium dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700">{props.currentPage}</a>

          <a onClick={() => changePage(props.currentPage)} key={props.currentPage} className="z-10 bg-blue-50 border-blue-500 text-blue-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium dark:bg-gray-600 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700">{props.currentPage + 1}</a>

          <a onClick={() => changePage(props.currentPage + 1)} key={props.currentPage + 1} className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50  md:inline-flex relative items-center px-4 py-2 border text-sm font-medium dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700">{props.currentPage + 2}</a>
          <a onClick={() => changePage(props.currentPage + 2)} key={props.currentPage + 2} className="bg-white border-gray-300 hidden text-gray-500 hover:bg-gray-50  sm:inline-flex relative items-center px-4 py-2 border text-sm font-medium dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700">{props.currentPage + 3}</a>

          <span key={-3} className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700">...</span>
          <a onClick={() => changePage(pageCount - 1)} key={pageCount} className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50  md:inline-flex relative items-center px-4 py-2 border text-sm font-medium dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700">{pageCount}</a>
        </>
      );
    }


    // Case for:  < | 1 | ... | 5 | 6 | 7 | 8 | 9 | >   ------------------------------------------------------------------
    if(pageCount > 6 && props.currentPage > pageCount - 5){
      let items = [];

      items.push(<a onClick={() => changePage(0)} className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50  md:inline-flex relative items-center px-4 py-2 border text-sm font-medium">1</a>);
      items.push(<span key={-4} className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700">...</span>);

      for (let i = pageCount-5; i < pageCount; i++) {
        if (props.currentPage === i) {
          items.push(<a onClick={() => changePage(i)} key={i} className="z-10 bg-blue-50 border-blue-500 text-blue-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium dark:bg-gray-600 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700">{i + 1}</a>); //Active page number
        }
        else {
          items.push(<a onClick={() => changePage(i)} key={i} className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50  md:inline-flex relative items-center px-4 py-2 border text-sm font-medium dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700">{i + 1}</a>); //Regular page number
        }
      }
      setPaginationBarContents(items);
    }
  }, [props.projectCount, props.currentPage]);


  return (
    <>
      {pageCount > 1 ? (
        <div className="float-right">
          <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
            <a
              onClick={() => previousPage()}
              className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700"
            >
              <span className="sr-only">Previous</span>
              <GoChevronLeft className="h-5 w-5" aria-hidden="true" />
            </a>
            {paginationBarContents}
            <a
              onClick={() => nextPage()}
              className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700"
            >
              <span className="sr-only">Next</span>
              <GoChevronRight className="h-5 w-5" aria-hidden="true" />
            </a>
          </nav>
        </div>
      ) : (
        <p></p>
      )}
    </>
  )
}